import React, { Fragment } from 'react';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import UsersEditContain from '../../../Component/Firms/EditFirm';
import { useTranslation } from 'react-i18next';


const UsersEdit = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Breadcrumbs parent={t("Firms")} title={t("Edit Firm")}  />
      <UsersEditContain />
    </Fragment>
  );
};
export default UsersEdit;
